import { useLocation, useNavigate } from "react-router-dom";

import useEvent from "./useEvent";

const useRedirectUrl = () => {
  const key = "__redirect_url__";

  return {
    setRedirectUrl: (url: string) => {
      // 一分钟有效期
      const data = {
        expire: new Date().getTime() + 60 * 1000,
        data: url,
      };
      localStorage.setItem(key, JSON.stringify(data));
    },
    getRedirectUrl: () => {
      const storedItem = localStorage.getItem(key);
      if (!storedItem) return "";
      
      const data = JSON.parse(storedItem);
      if (data && data.expire > new Date().getTime()) {
        return data.data;
      }
      return "";
    },
  };
};

const useNavigateLogin = () => {
  const navigate = useNavigate();

  const { pathname, search } = useLocation();

  const { setRedirectUrl, getRedirectUrl } = useRedirectUrl();

  const navigateLogin = useEvent((url = "/signin") => {
    const redirectUrl = pathname + search;
    setRedirectUrl(redirectUrl);
    navigate(url);
  });

  const saveCurrentUrl = useEvent(() => {
    const redirectUrl = pathname + search;
    setRedirectUrl(redirectUrl);
  });

  return {
    navigateLogin,
    getRedirectUrl,
    saveCurrentUrl,
  };
};

export default useNavigateLogin;
